import "core-js/modules/es.promise.finally.js";
import { useRef as n, useEffect as t, useState as e, useLayoutEffect as r } from "react";
import o from "lodash/debounce";
import i from "lodash/isEqual";

function u(n) {
  return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(n);
}

function c(n, t, e) {
  return t in n ? Object.defineProperty(n, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = e, n;
}

function f(n, t) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(n, t).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function a(n) {
  for (var t = 1; t < arguments.length; t++) {
    var e = null != arguments[t] ? arguments[t] : {};
    t % 2 ? f(Object(e), !0).forEach(function (t) {
      c(n, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : f(Object(e)).forEach(function (t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }

  return n;
}

function l(n, t) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, t) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(n))) return;
    var e = [],
        r = !0,
        o = !1,
        i = void 0;

    try {
      for (var u, c = n[Symbol.iterator](); !(r = (u = c.next()).done) && (e.push(u.value), !t || e.length !== t); r = !0) {
        ;
      }
    } catch (n) {
      o = !0, i = n;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }

    return e;
  }(n, t) || function (n, t) {
    if (!n) return;
    if ("string" == typeof n) return d(n, t);
    var e = Object.prototype.toString.call(n).slice(8, -1);
    "Object" === e && n.constructor && (e = n.constructor.name);
    if ("Map" === e || "Set" === e) return Array.from(n);
    if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return d(n, t);
  }(n, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function d(n, t) {
  (null == t || t > n.length) && (t = n.length);

  for (var e = 0, r = new Array(t); e < t; e++) {
    r[e] = n[e];
  }

  return r;
}

function v(e, r) {
  var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      i = o.options,
      c = o.enabled,
      f = void 0 === c || c,
      l = o.dependencies,
      d = void 0 === l ? [f, e] : l,
      v = o.element,
      y = n(function () {});
  t(function () {
    y.current = r;
  }, [r]), t(function () {
    if (!1 !== f) {
      if ("once" === f || !0 === f) {
        var n = function n(_n) {
          return y.current(_n);
        },
            t = a({}, i, {
          once: "once" === f
        });

        return (null != v ? v : document).addEventListener(e, n, t), function () {
          (null != v ? v : document).removeEventListener(e, n, t);
        };
      }

      console.error("Received value of type ".concat(u(f), " for property `enabled`. Expected a boolean."));
    }
  }, d);
}

function y(n, r, o) {
  var i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
      u = e(),
      c = l(u, 2),
      f = c[0],
      a = c[1];
  return t(function () {
    if (i) {
      var t = new MutationObserver(function () {
        a(o.apply(void 0, arguments));
      });
      return n && t.observe(n, r), function () {
        return t.disconnect();
      };
    }
  }, [n, r, o, i]), f;
}

function p() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function s() {
  var n = l(e(null), 2),
      r = n[0],
      i = n[1];
  return t(function () {
    i(p());
    var n = o(function () {
      return i(p());
    }, 100);
    return window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };
  }, []), r;
}

var b = function b(n, t) {
  return v("keydown", function (t) {
    return function (n, t) {
      27 === n.keyCode && (n.stopImmediatePropagation(), t());
    }(t, n);
  }, t);
};

function m() {
  var n = function n() {
    return "visible" === document.visibilityState;
  },
      r = l(e(!0), 2),
      o = r[0],
      i = r[1];

  return t(function () {
    i(n);
  }, []), v("visibilitychange", function () {
    i(n);
  }), o;
}

function h(e) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = r.interval,
      i = void 0 === o ? 3e4 : o,
      u = r.immediate,
      c = void 0 === u || u,
      f = r.enabled,
      a = void 0 === f || f,
      l = n(),
      d = m(),
      v = d && a;
  t(function () {
    l.current = e;
  }), t(function () {
    var n;
    if (v) return c ? r() : t(), e;

    function t() {
      e(), n = setTimeout(r, i);
    }

    function e() {
      clearTimeout(n);
    }

    function r() {
      var n;
      Promise.resolve(null === (n = l.current) || void 0 === n ? void 0 : n.call(l)).finally(t);
    }
  }, [i, c, v]);
}

function w(e) {
  var r = n();
  return t(function () {
    r.current = e;
  }), r.current;
}

function O(t) {
  var e = n();
  return void 0 !== e.current && i(e.current, t) || (e.current = t), e.current;
}

var g = function g() {
  var n = "undefined" == typeof window ? t : r;
  return n.apply(void 0, arguments);
};

export { b as useEscapeKey, v as useEventListener, g as useIsomorphicLayoutEffect, y as useMutationObserver, O as useObjectDependency, h as usePoller, w as usePrevious, s as useViewportSize };